import { dataLoading } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLoading = /*#__PURE__*/createIcon(dataLoading)
export default IconLoading
